import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "../../ui/card";

export default function SOEdit() {
  return (
    <div className="container mx-auto p-4">
      <Card className="max-w-2xl mx-auto">
        <CardHeader>
          <CardTitle>Edit Scheduled Offering</CardTitle>
          <CardDescription>
            Modify details of an existing Scheduled Offering
          </CardDescription>
        </CardHeader>
        <CardContent>
          <div className="text-center py-8">
            <p className="text-lg text-muted-foreground mb-4">Coming Soon</p>
            <p className="text-sm text-muted-foreground">
              This feature will allow administrators to edit existing Scheduled Offerings,
              update Program Leader assignments, modify dates, and manage program details.
            </p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}